export const HomeService = {
  Service: {
    Title: 'マイメニュー',
    More: '一覧を見る',
    AddService: '追加',
  },
};
